import { AuthFailType } from '../redux/actions/contactCenterActions';

export interface AuthErrorContent {
  title: string;
  body: string;
}

export const AUTH_ERROR_MESSAGES: Record<NonNullable<AuthFailType>, AuthErrorContent> = {
  AUTH_FAIL: {
    title: 'Session Expired',
    body: 'Your session has expired. Please log out and log back into the application to continue.'
  },
  ACCESS_DENIED: {
    title: 'Access Denied',
    body: "You don't have the required permissions to access Amazon Connect. Please contact your Admin or Support team to update your profile or permissions."
  },
  AUTHORIZE_RETRIES_EXHAUSTED: {
    title: 'Unable to Authenticate',
    body: `We are experiencing difficulty verifying your session due to network problems. 
          • Press OK, then capture CCP logs and browser Console logs before refreshing your browser. 
          • Refresh the page or log out and back in 
          • If the issue persists, then share the captured logs with the Engineering team for investigation.`
  },
  IFRAME_RETRIES_EXHAUSTED: {
    title: 'Connection Error',
    body: `We could not establish a secure connection to Amazon Connect. Please check your network and browser settings, then reload the page.
            • Press OK, then capture CCP logs and browser Console logs before refreshing your browser. 
            • Refresh the page or log out and back in 
            • If the issue persists, then share the captured logs with the Engineering team for investigation.`
  }
};
  